import { createContext } from 'react';
import type { INamespaceConfig } from './types';
import { ingleConfig } from './namespaces/ingle';

export const ConfigContext = createContext<INamespaceConfig>(ingleConfig);
